"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M7.165 15.85a1.07 1.07 0 0 1-1.507.077 1.063 1.063 0 0 1-.078-1.503l5.672-6.271a1.07 1.07 0 0 1 1.587.002l5.583 6.217c.393.438.356 1.11-.083 1.503a1.07 1.07 0 0 1-1.507-.083l-4.44-4.944a.473.473 0 0 0-.702 0L7.165 15.85Z"
})), "0 0 24 24", "ChevronUp");